import Client, {
  generateGraphqlMutation,
  generateGraphqlQuery,
  generateGraphqlCacheQuery,
} from "api/Client";

import { memberManagementUrl, paymentManagementUrl,paymentManagementUrl_V2 } from "constant";

const baseUrl = {
  endpoint: `${paymentManagementUrl}`,
};

const baseUrl_V2 = {
  endpoint: `${paymentManagementUrl_V2}`,
};



const memberUrl = {
  endpoint: `${memberManagementUrl}`,
};

const client = new Client(baseUrl);
const client_V2 = new Client(baseUrl_V2);

const member = new Client(memberUrl)
const apolloClient = client.apolloClient;

const AxiosInstance = client.AxiosInstance;
const AxiosInstance_V2 = client_V2.AxiosInstance;

const AxiosMember = member.AxiosInstance;
const graphqlMutation = generateGraphqlMutation(apolloClient);
const graphqlQuery = generateGraphqlQuery(apolloClient);

const graphqlCacheQuery = generateGraphqlCacheQuery(apolloClient);


export {
  apolloClient as gqlClient,
  AxiosMember,
  AxiosInstance,
  AxiosInstance_V2,
  graphqlMutation,
  graphqlQuery,
  graphqlCacheQuery,
};
